module.exports = __webpack_public_path__ + "img/BrandMe_IA_FotoPlantas_12.1d92e16b.png";